<template>
  <transition name="fade">
    <div class="download" v-if="isShow">
      <div class="left">
        <i class="iconfont icon-guanbi1" @click="isShow = false"></i>
        <img class="a" src="@/assets/downloadlogo.png" alt="">
        <span>纵享威士忌的魅力</span>
      </div>
      <img @click="$router.push({name:'download'})" class="b" src="@/assets/downloadlink.png" alt="">
    </div>
  </transition>
</template>

<script>
    export default {
        name: "download",
        data(){
            return {
              isShow:true
            }
        }
    }
</script>

<style scoped lang="less">
  .download {
    width: 100%;
    height: 1rem;
    position: relative;
    z-index: 9999;
    background: #333333;
    display: flex;
    align-items:center;
    justify-content:space-between;
    padding: 0 .24rem;
  .left {
    display: flex;
    align-items:center;
    .iconfont {
      color: white;
      font-size: .24rem;
      font-weight: 100;
      margin-right: .3rem;
      color: #cccccc;
    }
    span {
      color: #FFFFFF;
      margin-left: .16rem;
    }
  }
  .a {
    width: .72rem;
    height: .72rem;
  }
  .b {
    width: 1.6rem;
    height: .6rem;
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/download/download.vue